import Marquee from "react-fast-marquee";
import { useReducedMotion } from "framer-motion";
import { SERVICES } from "@/data/content";

const Item = ({ phrase }) => (
  <span className="flex items-center">
    <span className="mx-8 font-display text-5xl font-semibold uppercase tracking-tightest text-outline sm:text-6xl md:mx-12 md:text-8xl">
      {phrase}
    </span>
    <span className="font-display text-5xl font-semibold text-signal sm:text-6xl md:text-8xl">/</span>
  </span>
);

const SignatureMarquee = () => {
  const reduced = useReducedMotion();

  return (
    <section
      data-testid="marquee-section"
      aria-label="Services"
      className="overflow-hidden border-y border-line bg-ink py-8 md:py-12"
    >
      {reduced ? (
        <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-8 gap-y-4 px-6 md:px-12">
          {SERVICES.map((s) => (
            <span
              key={s}
              className="font-display text-3xl font-semibold uppercase tracking-tightest text-outline md:text-5xl"
            >
              {s}
            </span>
          ))}
        </div>
      ) : (
        <Marquee speed={32} gradient={false} autoFill pauseOnHover>
          {SERVICES.map((s) => (
            <Item key={s} phrase={s} />
          ))}
        </Marquee>
      )}
    </section>
  );
};

export default SignatureMarquee;
